<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: '',
  },
  moreUrl: {
    type: String,
    default: '',
  },
  moreText: {
    type: String,
    default: '查看更多',
  },
  side: {
    type: Boolean,
    default: false,
  },
  fontSize: {
    type: Number,
    default: 22,
  },
  moreFontSize: {
    type: Number,
    default: 16,
  },
  shadow: {
    type: Boolean,
    default: true,
  },
})

const hasExtraSlot = computed(() => {
  return !!useSlots().extra
})
</script>

<template>
  <div :class="`ref-card ${side ? 'side' : ''}`">
    <div v-if="title || moreUrl || hasExtraSlot" class="info">
      <h2 v-show="title" class="title" :style="`font-size: ${fontSize}px`">
        {{ title }}
      </h2>
      <div class="leftExtra">
        <slot name="leftExtra" />
      </div>
      <a v-show="moreUrl" :style="`font-size: ${moreFontSize}px`" class="more" :href="moreUrl" target="_blank">
        {{ moreText }}<RightOutlined />
      </a>
      <div class="extra">
        <slot name="extra" />
      </div>
    </div>
    <div :class="`content ${shadow ? 'shadow' : ''}`">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.ref-card {
  width: 100%;

  .info {
    height: 60px;
    line-height: 60px;
    box-sizing: border-box;
    background: #F5F5F6;
    border: 1px solid #D1D1D5;
    border-radius: 4px 4px 0px 0px;
    padding: 0 25px;
    position: relative;

    .title {
      font-weight: bold;
      float: left;
    }

    .leftExtra {
      float: left;
    }

    .extra {
      float: right;
    }

    .more {
      float: right;
      font-size: 16px;
      font-weight: normal;
      color: #3D3D3D;
      cursor: pointer;
    }
  }
  .content {
    width: 100%;
    border-radius: 0 0 4px 4px;
    box-sizing: border-box;
  }

  .shadow {
    border: 1px solid #EBEBEB;
    border-top: unset;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
  }
}
.side {
  border: 1px solid #E6E6E6;
  padding: 8px 13px;

  .content {
    margin-top: unset;
  }
}
</style>
